/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props, union } from '@ngrx/store';
import { StepChangeAnalyticsPayload } from '@arc/unified-payments-frontend/shared-payment';

export const StepChangeAnalyticsAction = createAction(
  '[BtPay Analytics] Checkout Step Change',
  props<{
    payload: StepChangeAnalyticsPayload;
  }>(),
);

export const TrackAnalyticsAction = createAction(
  '[BtPay Analytics] Generic Analytics Tracking',

  props<{
    eventKey: string;
    eventData: any;
  }>(),
);

const BtPayAnalyticsActions = union({
  StepChangeAnalyticsAction,
  TrackAnalyticsAction,
});

export type BtPayAnalyticsActionsUnion = typeof BtPayAnalyticsActions;
